import React, { useEffect, useState, useRef } from 'react';
import styles from './rankingReport.module.scss';
import RankDelta from '../common/rankDelta/rankDelta';
import { ILadderService } from '../../model/interfaces';
import PlayerRow from '../common/playerRow/playerRow';
import { Loader } from '@ui-kit/components/loader';
import { ReactComponent as Clock } from '../../assets/clock.svg';
import RangePicker, { RangeValue } from '@ui-kit/components/rangePicker';
import { t } from '@base/utils/helpers';
import { useAsyncData, useElementSize, useParentElementSize } from '@utils/hooks';
import classNames from 'classnames';

export default function RankingReport(props: { ladderService: ILadderService }) {
  const tableRef = useRef(null);
  const headerRef = useRef(null);
  const [dates, setRange] = useState<RangeValue>(null);
  const { data: events, loading, error } = useAsyncData(
    () => props.ladderService.getRankingReport(dates),
    dates
  );

  const { height: parentHeight } = useParentElementSize(tableRef);
  const { height: headerHeight } = useElementSize(headerRef);
  const bodyHeight = parentHeight - headerHeight;

  return (
    <table className={styles.report} ref={tableRef}>
      <thead ref={headerRef}>
        <tr>
          <th className={styles.bordered}>
            <DatePickerHeader onDateChange={setRange} />
          </th>
          <th>{t('player')} 1</th>
          <th className={classNames(styles.bordered, styles.rank)}>{t('rank')}</th>
          <th>{t('player')}2</th>
          <th className={styles.rank}>{t('rank')}</th>
        </tr>
      </thead>
      <tbody style={{ maxHeight: `${bodyHeight}px` }}>
        {!loading && events ? (
          events.map((event, index) => (
            <tr key={index}>
              <td className={styles.bordered}>
                <div className={styles.eventType}>
                  <span>{event.event_type}</span>
                  <span>{event.date}</span>
                </div>
              </td>
              <td>
                <PlayerRow name={event.players[0]?.name || ''} />
              </td>
              <td className={styles.bordered}>
                <RankDelta start={event.players[0].posStart} finish={event.players[0].posFinish} />
              </td>
              <td>{event.players[1] && <PlayerRow name={event.players[1].name || ''} />}</td>
              <td>
                <RankDelta start={event.players[1]?.posStart} finish={event.players[1]?.posFinish} />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5}>
              <Loader />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

function DatePickerHeader(props: { onDateChange: (dates: RangeValue) => void }) {
  const [visible, setVisible] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => props.onDateChange(null), [visible]);

  return (
    <div className={styles.datePickerHeader}>
      {visible ? (
        <RangePicker onChange={props.onDateChange} placeholder={[t('from'), t('to')]} />
      ) : (
        <span>{t('ladder_ranking')}</span>
      )}
      <Clock onClick={() => setVisible((v) => !v)} className={styles.clock} />
    </div>
  );
}
